<span class="odds-head" *ngIf="head" [innerHTML]="head"></span>
<span *ngIf="handicapVal && !isFootball" class="handicap-btn">{{ handicapVal }}</span>
<span class="odds-price" [textContent]="priceNum | oddsFormat: priceDen : priceType : isRacing" data-crlat="oddsPrice"></span>
